import { asText, Content } from '@prismicio/client';
import {
  JSXMapSerializer,
  PrismicRichText,
  SliceComponentProps,
} from '@prismicio/react';
import { JSX } from 'react';
import styles from './index.module.scss';

const components: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.text}>{children}</p>,
  heading6: ({ children }) => <h5 className={styles.textTitle}>{children}</h5>,
  oListItem: ({ children }) => (
    <p className={`${styles.text} ${styles.oListItem}`}>{children}</p>
  ),
  listItem: ({ children }) => (
    <p className={`${styles.text} ${styles.listItem}`}>
      <span>•</span>
      {children}
    </p>
  ),
};

export type TriPointModalProps =
  SliceComponentProps<Content.TriPointModalSlice>;

const TriPointModal = ({ slice }: TriPointModalProps): JSX.Element => {
  const lastUpdateText = asText(slice.primary.lastupdateline);
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={styles.wrapper}
    >
      {lastUpdateText && (
        <div className={styles.lastUpdate}>
          <PrismicRichText field={slice.primary.lastupdateline} />
        </div>
      )}
      <ul className={styles.list}>
        {slice.primary.blocks.map((block, key) => (
          <li key={key} className={styles.listBlock}>
            <div className={styles.title}>
              <PrismicRichText field={block.title} />
            </div>
            <div className={`${styles.text} ${styles.textWrapper}`}>
              <PrismicRichText components={components} field={block.text} />
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default TriPointModal;
